import React, { Component } from 'react'

import { Search } from '../../components/Icons'
import { Container, Title, InputContainer, IconContainer, StyledInput } from './styles'

class BrancheHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showTitle: true
    }
  }

  hideTitle() {
    this.setState({ showTitle: false })
  }

  showTitle() {
    this.setState({ showTitle: true })
  }

  render() {
    const { title, dark } = this.props

    return (
      <Container dark={dark}>
        <Title dark={dark} show={this.state.showTitle}>
          {title}
        </Title>

        <InputContainer dark={dark}>
          <IconContainer dark={dark}>
            <Search dark={dark} size="" />
          </IconContainer>

          <StyledInput
            dark={dark}
            type="text"
            name="search"
            placeholder="Zoeken"
            value={this.props.query}
            onChange={this.props.onSearch}
            onFocus={this.hideTitle.bind(this)}
            onBlur={this.showTitle.bind(this)}
            size="8"
          />
        </InputContainer>
      </Container>
    )
  }
}

export default BrancheHeader



// WEBPACK FOOTER //
// ./src/components/BrancheHeader/index.js